<div [ngClass]="{'tw-bg-[var(--sys-card)] tw-p-4 tw-shadow-md': withCard, 'tw-p-2': !withCard}"
    class="tw-border tw-border-[var(--sys-divider)] tw-rounded-2xl 
    tw-flex tw-flex-col tw-h-full tw-w-full tw-box-border"
>
    @if(cardTitle) {
        <h3 class="tw-text-[16px] tw-font-bold tw-tracking-wider tw-mt-0 tw-mb-3 tw-text-[var(--sys-secondary-text)] sticky-container">{{ cardTitle }}</h3>
    }
    <div class="tw-flex-grow">
        <ng-content></ng-content>
    </div>
</div>